import React from "react";

const CreateSegment = props => (
  <svg width={26} height={24} viewBox="0 0 26 24" {...props}>
    <g fillRule="evenodd">
      <path
        d="M6.69 16.303c.7-.26 1.268-.785 1.35-1.809v-1.802h1.5c1.578 0 2.47-1.71 2.47-3.043a2.413 2.413 0 00-2.055-2.386L7.852 7.24c.2-.267.416-.523.644-.765.368-.393.691-.883 1.123-1.205 1.527-1.143 3.5-1.69 5.55-1.69v9.21h9.17c0 5.087-4.105 9.21-9.17 9.21-3.825 0-7.103-2.353-8.478-5.697zM17.29 2C22.099 2 26 5.917 26 10.75h-8.711V2z"
        fillRule="nonzero"
      />
      <path d="M5.637 4.794c-.655 0-1.198.483-1.292 1.113l-.014.193v2.612H1.72a1.306 1.306 0 00-.194 2.599l.194.014H4.33v2.613a1.306 1.306 0 002.598.193l.015-.193v-2.613h2.612a1.306 1.306 0 00.193-2.598l-.193-.015H6.944V6.1c0-.722-.585-1.306-1.307-1.306z" />
    </g>
  </svg>
);

export default CreateSegment;
